module.exports = __webpack_public_path__ + "a66bedc4eda8e4f54ed560deebae2292.png";